<template>
  <div :class="{ 'buymeal-zhiyun-version': versionConfig.ZHIYUN_VERSION }">
    <a-row :gutter="20">
      <a-col :span="10">
        <div class="left-sec">
          <data-table ref="dataTable" :option="option" class="meal-table">
          </data-table>
        </div>
      </a-col>
      <a-col :span="14">
        <div class="right-sec">
          <h3 class="item-title">早餐选择</h3>
          <div class="detail-wrapper">
            <table class="detail-table">
              <thead>
                <tr>
                  <th width="150">房号</th>
                  <th width="150">项目</th>
                  <th width="150">数量</th>
                  <th width="100">单价</th>
                  <th>用餐日期</th>
                </tr>
              </thead>
              <tbody v-if="consumesData.length">
                <tr v-for="(item, index) in consumesData" :key="index">
                  <td width="150">{{ item.RoomNo }}</td>
                  <td width="150">
                    <a-select
                      style="width:100%"
                      v-model="item.AccountItemId"
                      @change="changeAccountItem"
                    >
                      <a-select-opt-group
                        v-for="aItem in accountList"
                        :key="aItem.Id"
                      >
                        <span slot="label">{{ aItem.TypeName }}</span>
                        <a-select-option
                          v-for="ele in aItem.AccountItems"
                          :value="ele.Id"
                          :key="ele.Id"
                        >
                          {{ ele.Name }}
                        </a-select-option>
                      </a-select-opt-group>
                    </a-select>
                  </td>
                  <td width="150">
                    <a-input-number
                      :min="1"
                      v-model="item.Quantity"
                      @change="countMoney"
                    />
                  </td>
                  <td width="100" style="text-align:right;">
                    {{ item.UnitPrice }}
                  </td>
                  <td><a-date-picker v-model="item.AccountDate" /></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="5" style="text-align:center;padding:20px">
                    暂无数据
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <h3 class="item-title">
            付款方式
            <a-button
              type="primary"
              size="small"
              icon="plus"
              @click="addPayment"
              style="margin:0 15px"
              :disabled="!consumesData.length"
              >增加收款</a-button
            ><span
              >消费金额：<em>{{ payMoney }}</em></span
            >
            <span class="total-money">
              合计：<em>{{ total }}</em>
            </span>
          </h3>
          <table class="payTable">
            <thead>
              <tr>
                <td width="120">付款方式</td>
                <td width="90">金额</td>
                <td width="100">单据号</td>
                <td width="130">会员</td>
                <td>备注</td>
                <td colspan="4"></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in paysInfo" :key="item.Id">
                <td>
                  <a-select
                    style="width: 100%;"
                    v-model="item.AccountItemId"
                    @change="onChangePayWay(index)"
                    allowClear
                    showSearch
                    :filterOption="filterOption"
                  >
                    <a-select-option
                      v-for="item1 in payway"
                      :key="item1.Id"
                      :value="item1.Id"
                      :disabled="item1.disabled"
                      >{{ item1.Name }}</a-select-option
                    >
                  </a-select>
                </td>
                <td>
                  <a-input-number
                    style="width:100%"
                    v-model="item.Money"
                    :min="0"
                    @change="countTotalMoney"
                  />
                </td>
                <td>
                  <a-input v-model="item.BillNo" />
                </td>
                <td>
                  <a-input v-model="item.TargetName" disabled />
                </td>
                <td>
                  <a-input v-model="item.Remark" />
                </td>
                <td>
                  <a-button
                    type="link"
                    @click="removePayment(index)"
                    size="small"
                    ><a-icon type="close" />删除</a-button
                  >
                </td>
                <td colspan="3"></td>
              </tr>
            </tbody>
          </table>
          <div class="btns">
            <a-button @click="reset">取消</a-button>
            <a-button
              type="primary"
              @click="onSubmit"
              :loading="loading"
              :disabled="!consumesData.length"
              >购买</a-button
            >
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import {
  OrderDetailModal,
  TeamOrderDetailModal
} from "@/views/orderManage/funtion.js";
import { cache, accAdd, accMul } from "@/utils/common";
// import { BankOrScanPayModal } from "@/views/orderManage/orderComponent/funtion.js";
import moment from "moment";
import "./buyBreakfast.less";
import cloneDeep from "lodash/cloneDeep";
export default {
  name: "BuyBreakfast",
  components: {
    DataTable
  },
  data() {
    return {
      versionConfig,
      option: {},
      loading: false,
      selectRow: {},
      consumesData: [],
      defaultItem: {},
      accountList: [],
      editColumns: [],
      props: {
        scroll: {}
      },
      paysInfo: [],
      payway: [],
      payMoney: 0,
      total: 0
    };
  },
  created() {
    this.$post("Room_GetDefaultTime", {}).then(res => {
      res.Data.SystemConstList.forEach(item => {
        this.defaultItem[item.Code] = item.Value;
      });
    });
    this.getAccountItemsGet();
    this.$post("Get_DepositList", { Types: "payway" }).then(res => {
      this.payway = res.Data.filter(
        item =>
          !(
            (item.Attributes & 2097152) > 0 ||
            (item.Attributes & 16777216) > 0 ||
            (item.Attributes & 33554432) > 0
          )
      );
    });
    this.AccountDate = cache.get("user").AccountDate;
    this.option = {
      headSearch: {
        width: 400,
        colnum: 1,
        content: [
          {
            label: "关键字",
            name: "Keyword",
            props: {
              placeholder: "房号/订单号/客人姓名"
            }
          }
        ]
      },
      grid: {
        api: "Breakfast_GetRoomNos",
        params: {
          OrderStatus: "1"
        },
        pagination: false,
        dataField: "Data",
        rowKey: "GuestId",
        columns: [
          {
            title: "订单号",
            width: "20%",
            dataIndex: "OrderNo",
            customRender: (text, record) => {
              const orderDetail = {
                click: e => {
                  e.stopPropagation();
                  this.orderDetail(record);
                }
              };
              return (
                <a-button type="link" size="small" {...{ on: orderDetail }}>
                  {text}
                </a-button>
              );
            }
          },
          {
            title: "房号",
            width: "30%",
            dataIndex: "RoomNo"
          },
          {
            title: "客人名称",
            dataIndex: "GuestName"
          }
        ],
        onLoad: res => {
          let data = [];
          const originData = cloneDeep(res.Data);
          originData.forEach(el => {
            if (el.AppointRoomInfos && el.AppointRoomInfos.length) {
              el.AppointRoomInfos.forEach(item => {
                item.OrderNo = el.OrderNo;
                item.OrderId = el.OrderId;
              });
              data = [...data, ...el.AppointRoomInfos];
            }
          });
          res.Data = data;
          return res;
        },
        selectedRows: rows => {
          this.selectRow = rows[0];
          if (this.selectRow) {
            if (!this.accountList.length) {
              this.$message.info("暂无早餐账项，请去系统维护->账务代码内设置");
              return false;
            }
            this.setAccountItem(this.selectRow);
          } else {
            this.reset();
          }
        }
      }
    };
    this.editColumns = [
      {
        title: "房号",
        width: "15%",
        dataIndex: "RoomNo"
      },
      {
        title: "客人名称",
        width: "15%",
        dataIndex: "GuestName"
      },
      {
        title: "价构名称",
        width: "20%",
        dataIndex: "PriceStructureName"
      },
      {
        title: "数量",
        align: "right",
        width: "15%",
        dataIndex: "Quantity",
        edit: {
          type: "number"
        },
        props: {
          min: 1
        }
      },
      {
        title: "单价",
        width: "15%",
        dataIndex: "UnitPrice"
      },
      {
        title: "用餐日期",
        dataIndex: "date",
        edit: {
          type: "date"
        }
      }
    ];
  },
  methods: {
    onSubmit() {
      if (!this.paysInfo.length) {
        this.$message.info("请添加付款方式！");
        return false;
      }
      const payList = this.paysInfo.filter(el => el.Money > 0);
      let json = {
        RoomInfoId: this.selectRow.RoomInfoId,
        Num: this.consumesData[0].Quantity,
        AccountDate: moment(this.consumesData[0].AccountDate).format(
          "YYYY-MM-DD"
        ),
        Consumes: this.consumesData,
        Pays: payList
      };
      const valid = this.paysInfo.some(
        el =>
          (Number(el.Money) != 0 && !el.AccountItemId) ||
          (el.Money == 0 && !el.AccountItemId && this.paysInfo.length == 1)
      );
      if (valid) {
        this.$message.info("请选择付款方式！");
        return false;
      }
      if (this.total != this.payMoney) {
        this.$message.info("付款金额总和与消费金额不一样，请重新填写！");
        return false;
      }
      this.loading = true;
      this.$post("Breakfast_Buy", json)
        .then(() => {
          this.$message.success("购买成功");
          this.loading = false;
          this.reset();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    reset() {
      this.paysInfo = [];
      this.consumesData = [];
      this.selectRow = {};
      this.payMoney = 0;
      this.total = 0;
      this.$refs.dataTable.getRef("dataGrid").setGridData("");
    },
    onChangePayWay() {
      // let paywayItem = this.payway.find(
      //   p => p.Id == this.paysInfo[index].AccountItemId
      // );
      // if (
      //   (paywayItem.Attributes & 131072) > 0 ||
      //   (paywayItem.Attributes & 262144) > 0 ||
      //   (paywayItem.Attributes & 524288) > 0
      // ) {
      //   let title = "",
      //     payType = "";
      //   if ((paywayItem.Attributes & 131072) > 0) {
      //     title = "银行卡消费";
      //     payType = 1;
      //   } else if ((paywayItem.Attributes & 262144) > 0) {
      //     title = "扫码消费";
      //     payType = 2;
      //   } else {
      //     title = "预授权";
      //     payType = 3;
      //   }
      //   this.paysInfo[index].Money = this.payMoney;
      //   BankOrScanPayModal({
      //     title: title,
      //     payType: payType,
      //     cannotChange: true,
      //     option: this.paysInfo[index],
      //     PaySign: 1,
      //     defaultItem: this.defaultItem,
      //     orderId: this.selectRow.OrderId,
      //     orderNo: this.selectRow.OrderNo,
      //     update: data => {
      //       if (data) {
      //         let json = {
      //           RoomInfoId: this.selectRow.RoomInfoId,
      //           Num: this.consumesData[0].Quantity,
      //           AccountDate: moment(this.consumesData[0].AccountDate).format(
      //             "YYYY-MM-DD"
      //           ),
      //           Consumes: this.consumesData
      //         };
      //         this.$post("Breakfast_Buy", json).then(res => {
      //           this.$message.success("购买成功");
      //           this.reset();
      //         });
      //       } else {
      //         this.paysInfo[index].AccountItemId = "";
      //       }
      //     }
      //   });
      // }
    },
    removePayment(index) {
      this.paysInfo.splice(index, 1);
      this.countTotalMoney();
    },
    addPayment() {
      const addCnt = {
        GuestId: this.selectRow.GuestId,
        AccountItemId: "",
        Money: 0,
        Quantity: 1,
        BillNo: this.selectRow.RoomNo,
        Remark: "",
        TargetName: "",
        OrderId: this.selectRow.OrderId
      };
      this.paysInfo.push(addCnt);
    },
    changeAccountItem(value) {
      this.accountList.forEach(el => {
        el.AccountItems.forEach(item => {
          if (item.Id == value) {
            this.selectRow.UnitPrice = item.UnitPrice;
            this.consumesData[0].UnitPrice = item.UnitPrice;
            this.consumesData[0].AccountName = item.Name;
            this.countMoney();
          }
        });
      });
    },
    countTotalMoney() {
      let money = 0;
      this.paysInfo.forEach(el => {
        money = accAdd(money, el.Money);
      });
      this.total = money;
    },
    countMoney() {
      this.payMoney = accMul(
        this.consumesData[0].UnitPrice,
        this.consumesData[0].Quantity
      ).toFixed(2);
      this.paysInfo[0].Money = this.payMoney;
      this.paysInfo[0].Remark =
        "购早：" +
        this.consumesData[0].Quantity +
        "份" +
        this.consumesData[0].AccountName;
      this.countTotalMoney();
    },
    setAccountItem(row) {
      this.consumesData = [];
      if (row) {
        const item = this.payway.find(
          el => (el.Attributes & 4096) > 0 && el.Name.includes("会员卡")
        );
        if (item) {
          item.disabled =
            !this.selectRow.MemberCardId || this.selectRow.MemberCardId == "0";
        }

        const json = {
          RoomNo: row.RoomNo,
          GuestId: row.GuestId,
          AccountItemId: this.accountList[0].AccountItems[0].Id,
          AccountName: this.accountList[0].AccountItems[0].Name,
          UnitPrice: this.accountList[0].AccountItems[0].UnitPrice,
          Quantity: 1,
          BillNo: row.RoomNo,
          AccountDate: moment(cache.get("user").AccountDate)
        };
        this.consumesData.push(json);
        this.setPayInfo();
      } else {
        this.paysInfo = [];
      }
    },
    setPayInfo() {
      this.paysInfo = [];
      let json = {
        GuestId: this.selectRow.GuestId,
        AccountItemId: "",
        Money: this.accountList[0].AccountItems[0].UnitPrice,
        Quantity: 1,
        BillNo: this.selectRow.RoomNo,
        Remark: "购早：1份" + this.accountList[0].AccountItems[0].Name,
        TargetName: "",
        OrderId: this.selectRow.OrderId
      };
      if (this.selectRow.MemberCardId && this.selectRow.MemberCardId != "0") {
        const item = this.payway.find(
          el => (el.Attributes & 4096) > 0 && el.Name.includes("会员卡")
        );
        json.AccountItemId = item ? item.Id : 0;
        json.TargetName = this.selectRow.MemberName;
        json.MemberCardId = this.selectRow.MemberCardId;
        json.MemberCardNo = this.selectRow.MemberCardNo;
      }
      this.paysInfo.push(json);
      this.payMoney = this.accountList[0].AccountItems[0].UnitPrice;
      this.total = this.payMoney;
    },
    getAccountItemsGet() {
      this.$post("Breakfast_AccountItemsGet", {}).then(res => {
        this.accountList = res.Data;
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    orderDetail(record) {
      if (this.defaultItem.PlusHotelOrderModel == 1) {
        TeamOrderDetailModal({
          orderId: record.OrderId,
          showBtn: false
        });
      } else {
        OrderDetailModal({
          orderId: record.OrderId,
          showBtn: false
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.item-title {
  font-size: 15px;
  font-weight: bold;
  width: 100%;
  background: rgba(24, 144, 255, 0.2);
  height: 34px;
  line-height: 34px;
  padding-left: 10px;
  font-weight: normal;
  em {
    font-style: normal;
    font-weight: normal;
    color: #f00;
  }
  .total-money {
    float: right;
  }
}
</style>
